module.exports = __webpack_public_path__ + "img/nt56-05-80-1-asm.prt.a298909d.jpg";